import React, { Component } from "react";
import AuthLayout from "./authLayout.js"
import SimpleReactValidator from 'simple-react-validator';

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'

import service from '../services'
import { Link } from "react-router-dom";
import Loader from '../component/loader'

import ViewIcon from './../icons/viewIcon';
import ShowPasswordIcon from './../icons/ShowPassIcon';
import Cookies from "universal-cookie";
import { ADMIN_ROLE } from "./../cosntants";

let sub;
const mapStateToProps = state => ({
    setToken: state.setToken,
    getLoginRole: state.getLoginRole,
    getBackToAdminPreviousPath: state.getBackToAdminPreviousPath
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
const cookies = new Cookies();
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            btnDisable: false,
            loaderFlag: false,
            showPass: false,
            selectedDropdown: '',
            roles: []
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();
    }

    componentDidMount = () => {
        if (this.props.setToken) {
            this.apiserve.sendevent("authentication", { token: this.props.setToken, role:localStorage.getItem('currentUserRole') });
        }

        this.apiserve.removeLocalstorage();
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "getUser":
                    this.props.ProfileName(response.data)
                    if (response.data.role === "sio" || response.data.role === "press" || response.data.role === "sundanceGuest" || response.data.role === "general" || response.data.role === "artist") {
                        this.props.history.push('/admin-dashboard')
                    } else if (response.data.role === "partner") {
                        this.props.history.push('/profile-partner-view')
                    } else if (response.data.role === "satellite") {
                        this.props.history.push('/profile-satellite-view')
                    }
                    else if (response.data.role === "privateScreeningPartner") {
                        if (this.state.mount)
                            this.props.history.push('/partners-film-view')
                        else this.setState({ mount: true });
                    }
                    else {
                        if (this.props.getBackToAdminPreviousPath === 'privateScreeningPartner') {
                            this.props.history.push('/partners-list')
                        } else {
                            this.props.history.push('/access-management')

                        }
                    }

                    break;
                case "admin|login":
                    if(response.error){
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                        this.setState({ loaderFlag: false, btnDisable: false })
                    } else if (!response.data.token) {
                        this.setState({ loaderFlag: false, btnDisable: false })
                        if (response.data && response.data.length > 0) {
                            const matchedRoles = ADMIN_ROLE.filter(role => response.data.includes(role.value));
                            this.setState({ roles: matchedRoles })
                        }
                    }
                    else if (response.data.token) {
                        let currDate = new Date();
                        let Time = process.env.REACT_APP_IDLE_LOGOUT_TIME
                        currDate.setTime(currDate.getTime() + (JSON.parse(Time)));
                        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "SessionLogout" : "SessionLogout", response.data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/', expires: currDate, secure: true });
                        let data = response.data;
                        const newRole = data.user.additionalRoles.length > 1 ? this.state.selectedDropdown : data.user.additionalRoles[0];
                        data.user.role = newRole;
                        localStorage.setItem('loginToken', response.data.token)
                        localStorage.setItem('currentUserRole', data.user.role)
                        this.props.LoginToken(response.data.token)
                        this.props.LoginRole(data)
                        this.props.LoginAdminByID(response.data.user._id)
                        this.setState({ btnDisable: false, loaderFlag: false })
                        this.apiserve.success("Login successful.")
                        if (data.user.role === "sio" ||
                            data.user.role === "press" ||
                            data.user.role === "sundanceCircle" ||
                            data.user.role === "sundanceGuest" ||
                            data.user.role === "general" ||
                            data.user.role === "artist") {
                            this.props.history.push('/admin-dashboard')
                        } else if (data.user.role === "partner") {
                            this.props.GetPartner(response.data)
                            this.props.history.push('/profile-partner-view')
                        }
                        else if (data.user.role === "privateScreeningPartner") {
                            if (this.state.mount)
                                this.props.history.push('/partners-list')
                            else this.setState({ mount: true });
                        }
                        else if (data.user.role === "satellite") {
                            if (this.state.mount)
                                this.props.history.push('/profile-satellite-view')
                            else this.setState({ mount: true });
                        }
                        else {
                            if (this.props.getBackToAdminPreviousPath === 'privateScreeningPartner') {
                                this.props.history.push('/partners-list')
                                this.props.BackToAdminPreviousPath('')
                            }
                            else if (this.props.getBackToAdminPreviousPath === 'partner') {
                                this.props.history.push('/partners-view')
                                this.props.BackToAdminPreviousPath('')
                            } else if (this.props.getBackToAdminPreviousPath === 'satellite') {
                                this.props.history.push('/satellites-view')
                                this.props.BackToAdminPreviousPath('')
                            } else {
                                this.props.history.push('/access-management')
                            }
                        }
                        this.apiserve.sendevent("getUser", { id: response.data.user._id });
                    }
                    break;
                case "authentication":
                    this.setState({ isAuthenticated: true, isLoading: false }, () => {
                        if (this.props.setToken) {
                            if (response && response.data && response.data.user && response.data.user.role === 'sio' ||
                                response && response.data && response.data.user && response.data.user.role === 'press' ||
                                response && response.data && response.data.user && response.data.user.role === 'sundanceGuest' ||
                                response && response.data && response.data.user && response.data.user.role === 'general' ||
                                response && response.data && response.data.user && response.data.user.role === 'artist') {
                                this.props.history.push('/admin-dashboard')
                            } else if (response && response.data && response.data.user && response.data.user.role === 'partner') {
                                this.props.history.push('/profile-partner-view')
                            } else if (response && response.data && response.data.user && response.data.user.role === 'satellite') {
                                this.props.history.push('/profile-satellite-view')
                            } else {
                                this.props.history.push('/access-management')
                            }
                        }
                    })
                    break;
                default:
                    return null
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    login = () => {
        let data = {
            email: this.state.email,
            password: this.state.password
        }
        if (this.state.roles.length > 0) {
            data.role = this.state.selectedDropdown
        }
        this.apiserve.sendevent("admin|login", data);
    }

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loaderFlag: true,
            });
            this.setState({ btnDisable: true })
            this.login();
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    clearFn = () => {
        this.setState({
            email: "",
            password: ""
        });
    };

    Showpassword = () => {
        this.setState({
            showPass: !this.state.showPass
        })
    }

    onInputChangeDropDown = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    logOut = (TYPE) => {
        const { getLoginRole, profileName } = this.props
        const user = getLoginRole && getLoginRole.user && getLoginRole.user.role
        if (user === 'privateScreeningPartner') {
            this.props.history.push('/ps-signin');
        }else if (TYPE !== 'FORCE') {
             this.props.history.push('/');
        }
        if (TYPE ==='FORCE') {
            window.location.reload()
        }
        this.props.LoginToken("");
        this.props.LoginRole("");
        this.props.LoginUser('')
        this.props.GetPartner("");
        this.props.GetPartnerEvent("")
        this.props.GetSatellite("");
        this.props.GetSatelliteEvent("")
        this.props.LoginAdminByID("")
        this.props.ProfileName("")
        this.props.BackToAdminPreviousPath('')
        localStorage.clear()
        this.setState({
            logoutLink: ""
        })
        this.props.BackToAdminFlag(false)
        this.props.ShortProgramEditData('')
        this.props.EpisodicShortProgramEditData('')
        this.props.filmEditData('')
        this.props.TalkEventEditData('')
        this.props.OtherEventsEditData('')
        this.props.NewFrontierEditData('')
        this.props.LiveSceeringEditData('')
        this.props.CurrentTab('')
        this.props.CurrentShortTab('')
    }

    render() {
        const { btnDisable } = this.state;
        return (
            <AuthLayout>
                {/* Box Design Start here */}
                <div className={`box_wrapper signIn_box_Wrapper ${this.state.roles.length > 0 ? "box_wrapper_height" : ""}`}>
                    <h2>Sign In</h2>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            <span style={{ color: 'red' }}>{this.validator.message('Email', this.state.email, 'required|email')}</span>
                        </div>
                        <div>
                            <label>Password</label>
                            <div className="relative">
                                <input
                                    type={this.state.showPass ? 'text' : 'password'}
                                    name="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.onInputChange} />
                                <span className="eye_icon" onClick={this.Showpassword}>
                                    {
                                        this.state.showPass ? <ShowPasswordIcon /> : <ViewIcon />
                                    }


                                </span>
                            </div>
                            <span style={{ color: 'red' }}>{this.validator.message('Password', this.state.password, 'required')}</span>
                        </div>
                        {this.state.roles.length > 0 &&
                            <div className="dashboard_wrapper">
                                <div className="form_group">
                                    <label>Login as</label>
                                    <div className="form_group_control relative">
                                        <div className="form_group_input form_group_select">
                                            <select
                                                value={this.state.selectedDropdown}
                                                className="custom"
                                                name={this.state.selectedDropdown}
                                                id='role'
                                                onChange={this.onInputChangeDropDown}
                                            >
                                                <option selected>Select an Option</option>
                                                {this.state.roles.map((e, key) => {
                                                    return <option key={key} value={e.value} disabled={e.value === 'Select an Option'} selected={e.value === this.state.selectedDropdown}>{e.label}</option>;
                                                })}
                                            </select>
                                        </div>
                                        <span style={{ color: 'red', position: 'absolute', bottom: '-18px' }}>{this.validator.message('Role', this.state.selectedDropdown === 'Select an Option' ? '' : this.state.selectedDropdown, 'required')}</span>
                                    </div>
                                </div>
                            </ div>}
                        <div>
                            <Link to='/forget'>Forgot Password</Link>
                        </div>
                        <div>
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                            >Clear</button>
                            <button
                                type="submit"
                                disabled={btnDisable === true ? true : false}
                                onClick={(e) => this.submitFn(e)}
                                className="orangeBTN"
                            >Submit</button>
                        </div>
                    </form>
                </div>
                {/* Box Design End's here */}

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}

            </AuthLayout>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)